import React from 'react'
import GravityFormForm from "gatsby-plugin-gravity-forms";
// import FileUpload from './file-upload'
import { useStaticQuery, graphql } from 'gatsby'

const handleError = ({values, error, reset}) => {
  //handle error
  console.log('error', values, error, reset)
}

const handleSuccess = ({values, reset, confirmations}) => {
  //handle success
  console.log('success', values, reset, confirmations)
}


const CareersForm = () => {
  // const controls = { fileupload: <FileUpload /> }
  const data = useStaticQuery(
      graphql`
          query {
            wpGfForm(databaseId: { eq: 5 }) {
              ...GravityFormFields
            }
          }
      `
  )
  return (<GravityFormForm
    data={data}
    lambda={process.env.GATSBY_LAMBDA_ENDPOINT}
    successCallback={handleSuccess}
    errorCallback={handleError}
    />
  )
}

export default CareersForm
